import { enqueueSnackbar, DownloadFile } from 'actions';

import {
	GetDatabaseNamesRequest,
	GetDatabaseYearsRequest,
	GetDatabaseMonthsRequest,
	DownloadDatabaseRequest

} from '../requests/DatasetExportRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const RESET_FIELDS = 'RESET_FIELDS';

export const GET_DATABASE_NAMES = 'GET_DATABASE_NAMES';
export const GET_DATABASE_YEARS = 'GET_DATABASE_YEARS';
export const GET_DATABASE_MONTHS = 'GET_DATABASE_MONTHS';

export const SET_SELECTED_DATABASE = 'SET_SELECTED_DATABASE';
export const SET_SELECTED_YEAR = 'SET_SELECTED_YEAR';
export const SET_SELECTED_MONTH = 'SET_SELECTED_MONTH';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onResetFields = () => ({
	type: RESET_FIELDS,
});

const onSetSelectedDatabase = (value) => ({
	type: SET_SELECTED_DATABASE,
	selectedDatabase: value
});

const onSetSelectedYear = (value) => ({
	type: SET_SELECTED_YEAR,
	selectedYear: value
});

const onSetSelectedMonth = (value) => ({
	type: SET_SELECTED_MONTH,
	selectedMonth: value
});

const onGetDatabaseNames = (value) => ({
	type: GET_DATABASE_NAMES,
	databases: value
});

const onGetDatabaseYears = (value) => ({
	type: GET_DATABASE_YEARS,
	years: value
});

const onGetDatabaseMonths = (value) => ({
	type: GET_DATABASE_MONTHS,
	months: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const ResetFields = () => (dispatch) => {
	dispatch(onResetFields());
};

export const SetSelectedDatabase = (selectedDatabase) => (dispatch) => {
	dispatch(onSetSelectedYear(selectedDatabase));
};

export const SetSelectedYear = (selectedYear) => (dispatch) => {
	dispatch(onSetSelectedYear(selectedYear));
};

export const SetSelectedMonth = (selectedMonth) => (dispatch) => {
	dispatch(onSetSelectedMonth(selectedMonth));
};

export const GetDatabaseNames = () => async (dispatch) => {
	await GetDatabaseNamesRequest().then(response => {
		dispatch(onGetDatabaseNames(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDatabaseYears = (databaseName) => async (dispatch) => {
	await GetDatabaseYearsRequest(databaseName).then(response => {
		dispatch(onGetDatabaseYears(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetDatabaseMonths = (databaseName, year) => async (dispatch) => {
	await GetDatabaseMonthsRequest(databaseName, year).then(response => {
		dispatch(onGetDatabaseMonths(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const DownloadDatabase = (databaseName, month, year, userId) => async (dispatch) => {
	await DownloadDatabaseRequest(databaseName, month, year, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
